interface TimeSpanProps {
  utc: number;
}

export default function TimeSpan({ utc }: Readonly<TimeSpanProps>) {
  const locale = 'uk-UA';
  const localDate = new Date(utc);
  const localString = localDate.toLocaleString(locale);

  return (
    <time title={localString} dateTime={localString}>
      {localDate.toLocaleTimeString(locale, { timeStyle: 'short' })}
    </time>
  );
}
